import { render, staticRenderFns } from "./DetailConfigurationSection.vue?vue&type=template&id=1b8b1602&scoped=true"
import script from "./DetailConfigurationSection.vue?vue&type=script&lang=js"
export * from "./DetailConfigurationSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8b1602",
  null
  
)

export default component.exports